// eslint-disable-next-line prefer-destructuring
export const SENTRY_ENVIRONMENT = import.meta.env.SENTRY_ENVIRONMENT;

// eslint-disable-next-line prefer-destructuring
export const SENTRY_DSN = import.meta.env.SENTRY_DSN;

// eslint-disable-next-line prefer-destructuring
export const VUE_APP_ENV = import.meta.env.VITE_APP_ENV;

// eslint-disable-next-line prefer-destructuring
export const VUE_APP_ROOT_API = import.meta.env.VITE_APP_ROOT_API;

// eslint-disable-next-line prefer-destructuring
export const VUE_APP_TITLE = import.meta.env.VITE_APP_TITLE;

// eslint-disable-next-line prefer-destructuring
export const VUE_APP_WS_HOST = import.meta.env.VITE_APP_WS_HOST;
